import produce from 'immer';
import { HEATMAP_MEASUREMENTS_ACTION } from './actions';

const defaultState = {
  measurements: [],
  measurementDetails: {},
  loading: false,
  measDetailsLoading: false,
  measurementAccessEmails: [],
  getAccessEmailsLoading: false,
  updateSharingStateLoading: false,

  isCustomerLoginLoading: false,
  isCustomerAuthenticated: false,
  dataUrl: null,
  nodes: {}, // areaNo: []

  csvDataLoading: false,
  measData: {},
};

const heatmapMeasurementsReducer = (state = defaultState, action) => {
  const { type: actionType, payload } = action;
  switch (action.type) {
    case HEATMAP_MEASUREMENTS_ACTION.GET_MEASUREMENTS:
    case HEATMAP_MEASUREMENTS_ACTION.DELETE_MEASUREMENT:
      return produce(state, (draft) => {
        draft.loading = true;
        draft.type = actionType;
      });
    case HEATMAP_MEASUREMENTS_ACTION.GET_MEASUREMENTS_SUCCESS:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.type = actionType;
        draft.measurements = payload;
      });
    case HEATMAP_MEASUREMENTS_ACTION.GET_MEASUREMENTS_FAILED:
    case HEATMAP_MEASUREMENTS_ACTION.DELETE_MEASUREMENT_SUCCESS:
    case HEATMAP_MEASUREMENTS_ACTION.DELETE_MEASUREMENT_FAILED:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.type = actionType;
      });

    case HEATMAP_MEASUREMENTS_ACTION.GET_MEASUREMENT_DETAILS:
      return produce(state, (draft) => {
        draft.measDetailsLoading = true;
        draft.type = actionType;
      });
    case HEATMAP_MEASUREMENTS_ACTION.GET_MEASUREMENT_DETAILS_SUCCESS:
      return produce(state, (draft) => {
        draft.measDetailsLoading = false;
        draft.measurementDetails = payload;
        draft.type = actionType;
      });
    case HEATMAP_MEASUREMENTS_ACTION.GET_MEASUREMENT_DETAILS_FAILED:
      return produce(state, (draft) => {
        draft.measDetailsLoading = false;
        draft.type = actionType;
      });

    case HEATMAP_MEASUREMENTS_ACTION.ADD_MEASUREMENT:
      return produce(state, (draft) => {
        draft.loading = true;
        draft.type = actionType;
      });
    case HEATMAP_MEASUREMENTS_ACTION.ADD_MEASUREMENT_SUCCESS:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.type = actionType;
        draft.measurements = [...state.measurements, payload];
      });
    case HEATMAP_MEASUREMENTS_ACTION.ADD_MEASUREMENT_FAILED:
      return {
        ...state,
        loading: false,
      };
    case HEATMAP_MEASUREMENTS_ACTION.UPDATE_MEASUREMENT_SETTINGS:
      return {
        ...state,
        loading: true,
        measDetailsLoading: true,
      };
    case HEATMAP_MEASUREMENTS_ACTION.UPDATE_MEASUREMENT_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        measDetailsLoading: false,
        measurementDetails: { ...state.measurementDetails, ...action.payload },
        measurements: state.measurements.map((meas) => {
          if (meas.measId === action.payload.measId) {
            return { ...meas, ...action.payload };
          } else {
            return meas;
          }
        }),
      };
    case HEATMAP_MEASUREMENTS_ACTION.UPDATE_MEASUREMENT_SETTINGS_FAILED:
      return {
        ...state,
        loading: false,
        measDetailsLoading: false,
      };
    case HEATMAP_MEASUREMENTS_ACTION.GET_HEATMAP_MEASUREMENT_ACCESS_EMAILS:
      return {
        ...state,
        getAccessEmailsLoading: true,
      };
    case HEATMAP_MEASUREMENTS_ACTION.GET_HEATMAP_MEASUREMENT_ACCESS_EMAILS_SUCCESS:
      return {
        ...state,
        getAccessEmailsLoading: false,
        measurementAccessEmails: action.payload,
      };
    case HEATMAP_MEASUREMENTS_ACTION.GET_HEATMAP_MEASUREMENT_ACCESS_EMAILS_FAILED:
      return {
        ...state,
        getAccessEmailsLoading: false,
      };
    case HEATMAP_MEASUREMENTS_ACTION.HEATMAP_MEASUREMENT_ADD_ACCESS_EMAILS:
      return {
        ...state,
        addAccessEmailLoading: true,
      };
    case HEATMAP_MEASUREMENTS_ACTION.HEATMAP_MEASUREMENT_ADD_ACCESS_EMAILS_SUCCESS:
      return {
        ...state,
        addAccessEmailLoading: false,
        measurementAccessEmails: [
          ...state.measurementAccessEmails,
          ...action.payload,
        ],
      };
    case HEATMAP_MEASUREMENTS_ACTION.HEATMAP_MEASUREMENT_ADD_ACCESS_EMAILS_FAILED:
      return {
        ...state,
        addAccessEmailLoading: false,
      };
    case HEATMAP_MEASUREMENTS_ACTION.HEATMAP_MEASUREMENT_DELETE_ALL_ACCESS_EMAILS:
      return {
        ...state,
        getAccessEmailsLoading: true,
      };
    case HEATMAP_MEASUREMENTS_ACTION.HEATMAP_MEASUREMENT_DELETE_ALL_ACCESS_EMAILS_SUCCESS:
      return {
        ...state,
        getAccessEmailsLoading: false,
        measurementAccessEmails: [],
      };
    case HEATMAP_MEASUREMENTS_ACTION.HEATMAP_MEASUREMENT_DELETE_ALL_ACCESS_EMAILS_FAILED:
      return {
        ...state,
        getAccessEmailsLoading: false,
      };
    case HEATMAP_MEASUREMENTS_ACTION.HEATMAP_MEASUREMENT_UPDATE_ACCESS_STATUS:
      return {
        ...state,
        updateSharingStateLoading: true,
      };
    case HEATMAP_MEASUREMENTS_ACTION.HEATMAP_MEASUREMENT_UPDATE_ACCESS_STATUS_SUCCESS:
      return {
        ...state,
        updateSharingStateLoading: false,
        measurementDetails: {
          ...state.measurementDetails,
          enabled: action.payload.enabled,
        },
      };
    case HEATMAP_MEASUREMENTS_ACTION.HEATMAP_MEASUREMENT_UPDATE_ACCESS_STATUS_FAILED:
      return {
        ...state,
        updateSharingStateLoading: false,
      };
    case HEATMAP_MEASUREMENTS_ACTION.DATA_SHARING_CUSTOMER_LOGIN:
      return {
        ...state,
        isCustomerLoginLoading: true,
      };
    case HEATMAP_MEASUREMENTS_ACTION.DATA_SHARING_CUSTOMER_LOGIN_SUCCESS:
      return {
        ...state,
        isCustomerLoginLoading: false,
        isCustomerAuthenticated: true,
        dataUrl: action.payload.dataUrl,
        measurementDetails: action.payload.measurement,
      };
    case HEATMAP_MEASUREMENTS_ACTION.DATA_SHARING_CUSTOMER_LOGIN_ERROR:
      return {
        ...state,
        isCustomerLoginLoading: false,
        isCustomerAuthenticated: false,
      };

    case HEATMAP_MEASUREMENTS_ACTION.GET_MEASUREMENT_AREAS:
      return produce(state, (draft) => {
        draft.loading = true;
        draft.type = actionType;
      });
    case HEATMAP_MEASUREMENTS_ACTION.GET_MEASUREMENT_AREAS_SUCCESS:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.type = actionType;
        draft.areas = payload;
      });
    case HEATMAP_MEASUREMENTS_ACTION.GET_MEASUREMENT_AREAS_FAILED:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.type = actionType;
      });

    case HEATMAP_MEASUREMENTS_ACTION.GET_MEASUREMENT_AREA_DETAILS:
      return produce(state, (draft) => {
        draft.loading = true;
        draft.type = actionType;
      });
    case HEATMAP_MEASUREMENTS_ACTION.GET_MEASUREMENT_AREA_DETAILS_SUCCESS:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.type = actionType;
        draft.area = payload;
        draft.nodes[payload.areaNo] = payload.nodes || [];
      });
    case HEATMAP_MEASUREMENTS_ACTION.GET_MEASUREMENT_AREA_DETAILS_FAILED:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.type = actionType;
      });

    case HEATMAP_MEASUREMENTS_ACTION.SAVE_MEASUREMENT_AREA_SETTINGS:
      return produce(state, (draft) => {
        draft.loading = true;
        draft.type = actionType;
      });
    case HEATMAP_MEASUREMENTS_ACTION.SAVE_MEASUREMENT_AREA_SETTINGS_SUCCESS:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.type = actionType;
        draft.area = payload;
        draft.nodes[payload.areaNo] = payload.nodes || [];
      });
    case HEATMAP_MEASUREMENTS_ACTION.SAVE_MEASUREMENT_AREA_SETTINGS_FAILED:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.type = actionType;
      });

    case HEATMAP_MEASUREMENTS_ACTION.GET_HEATMAP_MEASUREMENT_CSV_DATA:
      return produce(state, (draft) => {
        draft.csvDataLoading = true;
        draft.type = actionType;
      });
    case HEATMAP_MEASUREMENTS_ACTION.GET_HEATMAP_MEASUREMENT_CSV_DATA_SUCCESS:
      return produce(state, (draft) => {
        draft.csvDataLoading = false;
        draft.measData = { ...state.measData, ...payload };
        draft.type = actionType;
      });
    case HEATMAP_MEASUREMENTS_ACTION.GET_HEATMAP_MEASUREMENT_CSV_DATA_FAILED:
      return produce(state, (draft) => {
        draft.csvDataLoading = false;
        draft.type = actionType;
      });

    case HEATMAP_MEASUREMENTS_ACTION.ADD_NODE:
      return produce(state, (draft) => {
        draft.type = actionType;
        draft.nodes[payload.areaNo] = [
          ...(draft.nodes[payload.areaNo] || []),
          payload.node,
        ];
      });
    case HEATMAP_MEASUREMENTS_ACTION.DELETE_NODE:
      return produce(state, (draft) => {
        draft.type = actionType;
        draft.nodes[payload.areaNo] = (
          draft.nodes[payload.areaNo] || []
        ).filter((x) => x.no !== payload.nodeNo);
      });
    case HEATMAP_MEASUREMENTS_ACTION.SET_NODES:
      return produce(state, (draft) => {
        draft.type = actionType;
        draft.nodes[payload.areaNo] = payload.nodes;
      });
    case HEATMAP_MEASUREMENTS_ACTION.SET_NODE_POSITIONS:
      return produce(state, (draft) => {
        draft.type = actionType;
        draft.nodes[payload.areaNo] = payload.nodes;
      });

    default:
      return state;
  }
};

export default heatmapMeasurementsReducer;
